/** Lead fields that must not appear in Lead → object field mapping (system / conversion lookups). */
const EXCLUDED_BY_NAME = new Set([
  'id',
  'createddate',
  'createdbyid',
  'lastmodifiedbyid',
  'lastmodifieddate',
  'is_deleted',
  'is_converted',
  'company',
  'converted_account',
  'converted_contact',
  'converted_opportunity',
  'convertedaccountid',
  'convertedcontactid',
  'convertedopportunityid',
]);

const EXCLUDED_BY_LABEL = new Set([
  'converted account',
  'converted contact',
  'converted opportunity',
]);

/**
 * Decide whether a lead field should be hidden from the Lead → object field mapping UI.
 *
 * Pass `{ allowIdField: true }` to make the lead `id` field eligible for mapping.
 * Use this when the admin opts not to mark the lead as converted, so the converted
 * record can keep a lookup back to the original lead.
 */
export function isLeadFieldExcludedFromMapping(field, options = {}) {
  if (!field) return true;
  const name = String(field.field_name || '').toLowerCase();
  if (name === 'id' && options.allowIdField) {
    return false;
  }
  if (EXCLUDED_BY_NAME.has(name)) return true;
  const label = String(field.field_label || '').toLowerCase().trim();
  if (EXCLUDED_BY_LABEL.has(label)) return true;
  return false;
}

/** Account, Contact, Opportunity use built-in conversion for lead first/last name — no manual mapping. */
export const CORE_LEAD_CONVERSION_TARGET_KEYS = new Set(['account', 'contact', 'opportunity']);

export function isLeadFirstNameOrLastName(field) {
  const name = String(field?.field_name || '').toLowerCase();
  return name === 'first_name' || name === 'last_name';
}

export function isStandardConversionSkipsLeadNameMapping(field, targetKey) {
  if (!field || targetKey == null) return false;
  const key = String(targetKey).toLowerCase();
  if (!CORE_LEAD_CONVERSION_TARGET_KEYS.has(key)) return false;
  return isLeadFirstNameOrLastName(field);
}
